<template>
  <div class="print-box">
    <div class="print-n-box">
      <div id="printBox">
        <div
          style="page-break-before:always"
          class="print-mb100"
          v-for="(detailInfo,index) in batchPrintData"
          :key="index">
          <div style="font-size: 24px;font-weight: 600;border-bottom: 1px solid #ccc;padding-bottom: 15px;line-height: 60px;">
            <span>{{ $t('key1000204') }}</span>
            <span>{{ detailInfo.code }}</span>
            <span class="ml5">{{enmuMap[detailInfo.orderType]?.name ? ('(' + enmuMap[detailInfo.orderType]?.name +')') : ''}}</span>
            <font id="printSkuBarCode" style="font-family: IDAutomationC128S;margin-left: 10px; font-weight: normal; color: #000;"
              v-html="detailInfo.barCode"></font>
          </div>
          <div style="padding: 20px 0;border-bottom: 1px solid #ccc">
            <div>
              <span>
                <span class="textTitle">{{ $t('key1000205') }}</span>
                <span>{{ detailInfo.warehouseName }}</span>
              </span>
            </div>
            <div>
            <span style="display: inline-block;width: 250px">
              <span class="textTitle">{{ $t('key1000207') }}</span>
              <span>{{ detailInfo.packageGoodsType === 2 ? $t('key1000202') : $t('key1000203') }}</span>
            </span>
              <span style="display: inline-block;width: 180px">
                <span class="textTitle ab">{{ $t('key1000208') }}</span>
                <span>{{ detailInfo.packageQuantity }}</span>
              </span>
            </div>
            <div>
              <span style="display: inline-block;width: 250px">
                <span class="textTitle">{{ $t('key1001180') }}</span>
                <span>{{ $uDate.getDataToLocalTime(detailInfo.createdTime, 'fulltime') }}</span>
              </span>
              <span style="display: inline-block;width: 180px;white-space: nowrap">
                <span class="textTitle">{{ $t('key1000210') }}</span>
                <span>{{ detailInfo.skuNumber }}</span>
              </span>
            </div>
            <div>
            <span style="display: inline-block;width: 250px" v-if="type === 'pickList'">
              <span class="textTitle">{{ $t('key1000211') }}</span>
              <span>{{ detailInfo.pickedBy ? handleName(detailInfo.pickedBy) : '' }}</span>
            </span>
              <span v-if="type === 'pickList'">
                <span class="textTitle">{{ $t('key1000212') }}</span>
                <span>{{ detailInfo.skuQuantity }}</span>
              </span>
              <span style="display: inline-block;width: 250px" v-if="type === 'checkList' && detailInfo.checkStatus !== '0'">
                <span class="textTitle">{{ $t('key1004774') }}</span>
                <span>{{ detailInfo.checkUserName ? detailInfo.checkUserName : '' }}</span>
              </span>
            </div>
          </div>
          <!--表格-->
          <table width="100%">
            <thead style="background-color: #ccc">
            <tr>
              <th style="padding: 6px 0" v-show="filterColumns.includes('goodsUrl')">
                {{ $t('key1000585') }}
              </th>
              <th style="padding: 6px 0" v-show="filterColumns.includes('warehouseBlockName')">
                {{ $t('key1000213') }}
              </th>
              <th style="padding: 6px 0" v-show="filterColumns.includes('warehouseLocationName')">
                {{ $t('key1000214') }}
              </th>
              <th style="padding: 6px 0" v-show="filterColumns.includes('spu')">SPU</th>
              <th style="padding: 6px 0" v-show="filterColumns.includes('goodsSku')">SKU</th>
              <th style="padding: 6px 0" v-show="filterColumns.includes('ymsSpu')">{{ configCharacters(false) + 'SPU' }}</th>
              <th style="padding: 6px 0" v-show="filterColumns.includes('ymsSku')">{{ configCharacters(false) + 'SKU' }}</th>
              <th style="padding: 6px 0" v-if="type === 'pickList' && filterColumns.includes('expectedNumber')">
                {{ $t('key1000215') }}
              </th>
              <th style="padding: 6px 0" v-show="filterColumns.includes('goodsCnDesc')">
                {{ $t('key1000216') }}
              </th>
              <th style="padding: 6px 0" v-show="filterColumns.includes('goodsAttributes')">
                {{ $t('key1000217') }}
              </th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(val, i) in detailInfo.ymsPickingOrderDetails" :key="i">
              <td align="center" style="white-space: nowrap" v-show="filterColumns.includes('goodsUrl')">
                <img :src="setImgPath(val._productInfo.primaryImage)" width="80" height="80" crossOrigin="anonymous" style="margin: 10px"/>
              </td>
              <td
                align="center"
                style="white-space: nowrap"
                v-show="filterColumns.includes('warehouseBlockName')">{{ val.warehouseBlockName }}
              </td>
              <td align="center" style="white-space: nowrap" v-show="filterColumns.includes('warehouseLocationName')">
                {{ val.warehouseLocalName }}
              </td>
              <td align="center" style="word-break: break-all;" v-show="filterColumns.includes('spu')">
                {{ val._productInfo._spuInfo.supplierSpu }}
              </td>
              <td align="center" style="word-break: break-all;" v-show="filterColumns.includes('goodsSku')">
                {{ val._productInfo.supplierSku }}
              </td>
              <td align="center" style="word-break: break-all;" v-show="filterColumns.includes('ymsSpu')">
                {{ val._productInfo._spuInfo.ymsSpu }}
              </td>
              <td align="center" style="word-break: break-all;" v-show="filterColumns.includes('ymsSku')">
                {{ val._productInfo.ymsSku }}
              </td>
              <td align="center" v-if="type === 'pickList' && filterColumns.includes('expectedNumber')">
                {{ val.quantity - val.pickedQuantity }}
              </td>
              <td align="center" style="word-break: break-all;" v-show="filterColumns.includes('goodsCnDesc')">
                {{ val._productInfo._spuInfo.name }}
              </td>
              <td align="center" style="word-break: break-all;" v-show="filterColumns.includes('goodsAttributes')">
                {{ val._productInfo.productGoodsSpecificationList ? val._productInfo.productGoodsSpecificationList.map(i => i.value).join('&') : '' }}
              </td>
            </tr>
            </tbody>
          </table>
          <div class="clear">
            <div class="fr" style="margin-top: 50px">
              <span style="margin-right: 100px;font-size: 14px">{{ $t('key1004775') }} {{ $t('key1004776') }}</span><span style="margin-right: 100px;font-size: 14px">{{ $t('key1004734') }} {{ $t('key1004777') }}</span>
            </div>
          </div>
        </div>
      </div>
      <div style="position: absolute;right: -125px;top:0" class="print-none">
        <div style="margin-bottom: 10px">
          <Button type="primary" @click="print">{{ $t('key1000320') }}</Button>
        </div>
        <div style="margin-bottom: 10px">
          <Button type="primary" @click="download">{{ $t('key1000554') }}</Button>
        </div>
        <div style="margin-bottom: 10px">
          <Button type="primary" @click="cancelPrint">{{ $t('key1004778') }}</Button>
        </div>
        <div style="height: 35px;position: relative">
          <local-filterColumns
            :columns="columns"
            :filterName="'printPickList'"
            @setTableColumns="setTableColumns"></local-filterColumns>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

// 打印盘点单与拣货单共用模块
import api from '@/api/';
import common from '@/components/mixin/common_mixin';
import pdf from '@/utils/pdf';
import printMixin from '@/components/mixin/print_mixin';
import {
  getAllUsersInfo, getAllYmsWarehouseData, getDataSetMap, getUserNameByUserId, getWarehouseManageInfo,
  getWarehouseName, setConfigCharacters
} from "@/utils/common";

export default {
  // type === 'checkList'为盘点单
  mixins: [common, printMixin],
  data() {
    let v = this;
    let columns1 = [
      {
        title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000585'),
        key: 'goodsUrl'
      },
      {
        title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000213'),
        key: 'warehouseBlockName'
      }, {
        title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000214'),
        key: 'warehouseLocationName'
      }, {
        title: 'SPU',
        key: 'spu'
      }, {
        title: 'SKU',
        key: 'goodsSku'
      }, {
        title: `${setConfigCharacters(false)}SPU`,
        key: 'ymsSpu'
      }, {
        title: `${setConfigCharacters(false)}SKU`,
        key: 'ymsSku'
      }, {
        title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000216'),
        key: 'goodsCnDesc'
      }, {
        title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000217'),
        key: 'goodsAttributes'
      }, {
        title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000219'),
        key: 'receiptBatchNo',
        filterHide: true
      }
    ];
    let columns2 = JSON.parse(JSON.stringify(columns1));
    let columns3 = JSON.parse(JSON.stringify(columns1));
    columns2.splice(2, 0, {
      title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000215'),
      key: 'expectedNumber'
    });
    columns3.push({
      title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004763'),
      key: 'blindFlag',
      render(h, params) {
        let data = v.detailInfo.blindFlag === '1' ? '*' : params.row.oriTotalNumber;
        return h('span', data);
      }
    }, {
      title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004764'),
      key: 'countingQuantity'
    }, {
      title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004765'),
      key: 'gainsAndLosses'
    });
    return {
      warehouseList: [],
      detailInfo: [],
      type: '',
      batchPrintData: [],
      columns: [],
      filterColumns: [],
      columns2: columns2,
      columns3: columns3,
      userInfoList: {},
      enmuMap: {}
    };
  },
  created() {
    this.type = this.$route.query.type;
    this.where = this.$route.query.where;
    this.goodsSkuOrGoodsCnDesc = this.$route.query.goodsSkuOrGoodsCnDesc;
    this.columns = this.columns2;
    this.initData();
  },
  destroyed() {
    localStorage.removeItem('paramsDtl');
  },
  methods: {
    // 初始化数据
    async initData() {
      this.enmuMap = await getDataSetMap('OrderTypeOrderEnum');
      this.userInfoList = await getAllUsersInfo();
      await getAllYmsWarehouseData().then((data) => {
        this.warehouseList = data;
        let obj = this.$route.query.data;
        this.axios.get(api.get_ymsPickingOrder_pickingOrderGoodsDetailList + '?ymsPickingOrderIds=' + obj.split(',')).then(response => {
          if (response.data.code === 0) {
            let datas = response.data.datas;
            let ymsProductGoodsIds = [];
            let ymsWarehouseLocationIds = [];
            let codes = [];
            datas.forEach(i => {
              codes.push(i.code);
              i.ymsPickingOrderDetails.forEach(j => {
                ymsProductGoodsIds.push(j.ymsProductGoodsId);
                ymsWarehouseLocationIds.push(j.ymsWarehouseLocationId);
              });
            });
            if (ymsProductGoodsIds.length) {
              (async () => {
                let data = await getWarehouseManageInfo([...new Set(ymsWarehouseLocationIds)], {
                  data: datas,
                  childKey: ['ymsPickingOrderDetails']
                });
                data = await this.getProductInfoByIds([...new Set(ymsProductGoodsIds)], {
                  data: data,
                  childKey: ['ymsPickingOrderDetails']
                });
                data = await this.getBarCodes([...new Set(codes)], data);
                data = this.getDataWarehouseName(data);
                this.batchPrintData = data;
              })();
            } else {
              this.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004963'));
            }
          }
        });
      });
    },
    // 处理操作人名称
    handleName(pickedBy) {
      let name = getUserNameByUserId(pickedBy, this.userInfoList);
      return name;
    },
    getDataWarehouseName(data) {
      return data.map(i => {
        i.warehouseName = getWarehouseName(this.warehouseList, i.ymsWarehouseId);
        return i;
      });
    },
    setTableColumns(data) {
      this.filterColumns = data.map(i => i.key);
    },
    cancelPrint() {
      window.location.href = '#/wms/pickList';
    },
    print() {
      let obj = this.$route.query.data;
      this.axios.put(api.put_ymsPickingOrder_markPrinted, obj.split(',')).then(res => {
        if (res.data.code === 0) {
          this.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004964'));
        }
      });
      window.print();
    },
    getBarCodes(arr, data) {
      let v = this;
      return new Promise(resolve => {
        v.axios.post(api.put_erpCommon_getBarCodes, arr).then(response => {
          if (response.data.code === 0) {
            data.forEach(i => {
              response.data.datas.forEach(j => {
                if (j[i.code]) {
                  i.barCode = j[i.code];
                }
              });
            });
            resolve(data);
          }
        });
      });

    },
    download() {
      pdf('#printBox', 'web');
    }
  }
};
</script>
<style>
.iview-table-setWidth .ivu-table:before {
  height: 0;
}

.iview-table-setWidth .ivu-table:after {
  height: 0;
}

.print-mb100 {
  margin-bottom: 100px;
}

.print-n-box {
  width: 1000px;
  background-color: #fff;
  margin: 0 auto;
  height: 100%;
  position: relative;
}

.print-box {
  background-color: #ccc;
  padding: 34px 56px;
  font-size: 16px;
}

#printBox {
  padding: 20px;
}

.iview-table-setWidth .ivu-table-overflowX {
  overflow: hidden;
}

.print-n-box .ivu-table-wrapper {
  border: 1px solid #999;
  border-bottom: 0;
}

.print-n-box .ivu-table td,
.print-n-box .ivu-table th {
  border-bottom: 1px solid #999;
}

@page {
  margin: 0;
  padding: 0;
}

@media print {
  html,
  body,
  #app {
    min-width: auto;
    height: auto !important;
    min-height: auto !important;
    overflow: visible !important;
  }

  .layout,
  .main_container,
  .content_container,
  .ivu-layout,
  .ivu-layout-content,
  .print-box,
  .print-n-box,
  #printBox {
    height: auto !important;
    max-height: none !important;
    overflow: visible !important;
  }

  * {
    margin: 0;
    padding: 0;
    font-weight: bold;
  }

  .iview-table-setWidth .ivu-table-header table {
    width: 100% !important;
    table-layout: initial;
  }

  .iview-table-setWidth .ivu-table-body table {
    width: 100% !important;
    table-layout: initial;
  }

  .iview-table-setWidth .ivu-table:before {
    height: 0;
  }

  .iview-table-setWidth .ivu-table:after {
    height: 0;
  }

  .print-n-box .ivu-table-wrapper {
    border: 1px solid #999;
    border-bottom: 0;
  }

  .print-n-box .ivu-table td,
  .print-n-box .ivu-table th {
    border-bottom: 1px solid #999;
  }

  #printBox {
    padding: 0 !important;
  }

  table {
    page-break-inside: auto;
  }

  thead {
    display: table-header-group;
  }

  tfoot {
    display: table-footer-group;
  }

  tr,
  img {
    break-inside: avoid;
    page-break-inside: avoid;
  }

  .print-n-box {
    width: 100%;
    background-color: #fff;
    margin: 0 auto;
    position: relative;
    padding: 0 16px;
  }

  .print-box {
    width: 100%;
    font-size: 16px;
    background-color: #ccc;
    padding: 0;
  }

  .print-mb100 {
    margin-bottom: 5pt;
  }

  .print-none {
    display: none;
  }
}

.textTitle {
  font-size: 16px;
  width: 150px;
}

* {
  margin: 0;
  padding: 0;
}

.print-box .filterColumns {
  position: absolute;
  left: 0px;
  bottom: 0px;
  width: 100px;
  height: 32px;
}
</style>
<style scoped>
table {
  -webkit-border-horizontal-spacing: 0px;
  -webkit-border-vertical-spacing: 0px;
  border-top-width: 0px;
  border-right-width: 0px;
  border-bottom-width: 0px;
  border-left-width: 0px;
  border-top: 1px solid #9a9a9a;
  border-left: 1px solid #9a9a9a;
}

.table-border {
  border: 1px solid #666;
  border-bottom: 0;
  border-right: 0;
}

table td,
table th {
  border-bottom: 1px solid #9a9a9a;
  border-right: 1px solid #9a9a9a;
}
</style>
